export default "__VITE_ASSET__BG$HSDkN__"